<template>
  <section class="app-main">
    <el-scrollbar view-style="height: 100%;">
      <router-view v-slot="{ Component }">
        <transition name="fade-transform" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </el-scrollbar>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped>
.app-main {
  flex: 1;
  overflow: hidden;
}
</style>
